import React from 'react';

interface VireonLogoIconProps {
  className?: string;
  size?: number;
}

export const VireonLogoIcon: React.FC<VireonLogoIconProps> = ({ className, size = 16 }) => {
  return (
    <svg
      width={size}
      height={size * 0.75}
      viewBox="0 0 200 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Main horizontal line passing through the center */}
      <line x1="0" y1="75" x2="200" y2="75" stroke="currentColor" strokeWidth="8" strokeLinecap="round" />
      
      {/* Symmetrical upper wing shape */}
      <path
        d="M 50 75 
           C 50 50, 75 25, 110 25 
           L 155 25 
           C 170 25, 180 35, 180 50 
           L 180 75 
           C 180 75, 155 75, 135 75 
           L 135 55 
           C 135 48, 125 45, 115 45
           L 95 75 
           Z"
        fill="currentColor"
      />
      
      {/* Symmetrical lower wing shape (180 degree rotation of upper wing) */}
      <path
        d="M 150 75 
           C 150 100, 125 125, 90 125 
           L 45 125 
           C 30 125, 20 115, 20 100 
           L 20 75 
           C 20 75, 45 75, 65 75 
           L 65 95 
           C 65 102, 75 105, 85 105
           L 105 75 
           Z"
        fill="currentColor"
      />
    </svg>
  );
};
